"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BandwidthChangeHandler = void 0;
exports.getNetworkQuality = getNetworkQuality;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _underscore = require("underscore");
var _constants = require("@studio/constants");
function getNetworkQuality(bandwidth) {
  var value = bandwidth / 10;
  if (!value) {
    return '';
  }
  if (value >= 140) {
    return _constants.NETWORK_HEALTH_EXCELLENT;
  } else if (value >= 65) {
    return _constants.NETWORK_HEALTH_GOOD;
  } else {
    return _constants.NETWORK_HEALTH_POOR;
  }
}
var WAIT = 7000;
var BandwidthChangeHandler = exports.BandwidthChangeHandler = /*#__PURE__*/function () {
  function BandwidthChangeHandler(callback) {
    var _this = this;
    (0, _classCallCheck2["default"])(this, BandwidthChangeHandler);
    this.currentBandwidth = null;
    this.throttledCallback = (0, _underscore.throttle)(function (newBandwidth) {
      callback(newBandwidth);
      _this.currentBandwidth = newBandwidth;
    }, WAIT);
  }
  (0, _createClass2["default"])(BandwidthChangeHandler, [{
    key: "onChange",
    value: function onChange(newBandwidth) {
      if (isNaN(newBandwidth)) return;
      // update - needs to be throttled
      if (this.currentBandwidth === null || this.getQualityHasChanged(newBandwidth)) {
        this.fireCallback(newBandwidth);
      }
    }
  }, {
    key: "getQualityHasChanged",
    value: function getQualityHasChanged(newBandwidth) {
      return getNetworkQuality(newBandwidth) !== getNetworkQuality(this.currentBandwidth);
    }
  }, {
    key: "fireCallback",
    value: function fireCallback(newBandwidth) {
      this.throttledCallback(newBandwidth);
    }
  }]);
  return BandwidthChangeHandler;
}();